// @ts-strict-ignore
import React from 'react';
import styled from 'styled-components';
import { BorderProps } from 'styled-system';

import { ThreeSectionSliderImageSizes } from 'api/cms';
import { FilestackImageWithTextData } from 'api/types/shared.types';
import { Box } from 'components/Box';
import { FilestackImage } from 'components/Image';
import { BodySmall } from 'components/Text';

import { THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES } from './threeSectionSliderConstants';

const ImageContainer = styled(Box)`
  display: flex;
  justify-content: center;

  img {
    height: 100%;
    max-width: 100%;
  }
`;

type Props = BorderProps & {
  imageQaId: string;
  image: FilestackImageWithTextData | null | undefined;
  imageSize: ThreeSectionSliderImageSizes;
  text: string;
  withImages: boolean;
};

export function ThreeSectionSliderBlockSection({
  imageQaId,
  image,
  imageSize,
  text,
  withImages,
  ...props
}: Props) {
  const height = THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES[imageSize];

  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Box flex="0 0 auto" width="100%" height="100%" {...props}>
      <Box
        maxWidth="320px"
        display="flex"
        height="100%"
        alignItems="center"
        justifyContent="flex-start"
        flexDirection="column"
        width="100%"
        m="0 auto"
        p={['24px 20px', '24px 0', '0 32px']}
      >
        {(image || withImages) && (
          <ImageContainer height={height + 26} width="100%">
            {image && (
              <FilestackImage
                data-qa-id={imageQaId}
                alt={image.altText}
                data={image}
                height={height}
                quality={imageSize === 'SMALL' ? 'high' : undefined}
              />
            )}
          </ImageContainer>
        )}
        <Box width="100%" textAlign="center">
          <BodySmall
            dangerouslySetInnerHTML={{
              __html: text,
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
